import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { FC, useState } from 'react';
import { DialogContent, DialogContentText, TextField } from '@mui/material';
import { TConfirmationWithCommentDialogProps } from './types';

export const ConfirmationWithCommentDialog: FC<TConfirmationWithCommentDialogProps> = ({
	open,
	setClose,
	handleConfirm,
	title = '',
	text = '',
	comment,
	setComment,
}) => {
	return (
		<Dialog
			open={open}
			onClose={setClose}
			sx={{
				'& .MuiDialog-paper': {
					width: '500px',
					maxWidth: '500px',
					borderRadius: '12px',
				},
			}}
		>
			<DialogTitle color="primary" dangerouslySetInnerHTML={{ __html: title }} />
			<DialogContent>
				<DialogContentText dangerouslySetInnerHTML={{ __html: text }} />
				<TextField
					label="Comment"
					multiline
					rows={4}
					sx={{
						width: '100%',
						marginTop: '20px',
					}}
					value={comment}
					onChange={e => setComment(e.target.value)}
				/>
			</DialogContent>
			<DialogActions>
				<Button onClick={setClose}>Cancel</Button>
				<Button onClick={() => handleConfirm(comment)} autoFocus>
					Confirm
				</Button>
			</DialogActions>
		</Dialog>
	);
};
